import { connect } from 'react-redux';
import { addCitationCommentBegin } from '../../../../store/actions/citation.actions';
import { getAddCitationCommentLoader, getCitationCommentList } from '../../../../store/selectors/citation.selectors';
import CitationComment from './CitationComment';
const mapStateToProps = (state: any) => {
    const loading = getAddCitationCommentLoader(state);
    const citationCommentList = getCitationCommentList(state);
    return {
        loading,
        citationCommentList,
    };
};

const mapDispatchToProps = {
    addCitationComment: addCitationCommentBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(CitationComment);
